import React from 'react'

const LiveIndicator = ({bg}) => {
  return <div className={`live-dot bg-${bg}`}></div>;
}

export default LiveIndicator;